import BaseComponent from '../../base/base_component';
import DOM from '../../utils/dom';
import * as OverlayConst from './overlay_const';

export interface IOverlayWrapperComponentController{
    getEl(): HTMLElement;
    start(): BaseComponent;
}

class OverlayWrapperComponentController extends BaseComponent implements IOverlayWrapperComponentController{

    static CLASS: string = 'OverlayComponentController';
    protected _selector: string = 'cgp-overlay-wrapper-component';

    public start(): BaseComponent {
        const overlayElement = DOM.$$('.cgp-overlay-wrapper-component');
        if (!overlayElement || overlayElement.length === 0) {
            this.getEl().className = OverlayConst.OVERLAY_DOM_PROPERTIES.CLASS_NAME;

            DOM.addClass(this.getEl(), OverlayConst.LIGHTBOX_BACKGROUND_COLOR_CLASS)
                .draw(this.getEl());
        }
        return this;
    }
}

export default OverlayWrapperComponentController;